























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import CounterItemWrapper from '@/components/counters/CounterItemWrapper.vue';

import WaterCounterSvg from '@/components/counters/svgs/WaterCounterSvg.vue';
import EnergyCounterSvg from '@/components/counters/svgs/EnergyCounterSvg.vue';
import GasCounterSvg from '@/components/counters/svgs/GasCounterSvg.vue';
import HeatCounterSvg from '@/components/counters/svgs/HeatCounterSvg.vue';
import CounterEditDialog from '@/components/counters/CounterEditDialog.vue';
import { Counter } from '@/modules/backend/Entities/Counter';
import { pad } from '@/filters/pad';

function lastDigits(x: number): string {
  return x.toLocaleString('us').split(',').reverse()[0][0];
}

@Component({
  filters: {
    pad,
  },
  components: {
    'app-counter-edit-dialog': CounterEditDialog,
    'app-counter-item-wrapper': CounterItemWrapper,
    'app-water-counter-svg': WaterCounterSvg,
    'app-energy-counter-svg': EnergyCounterSvg,
    'app-gas-counter-svg': GasCounterSvg,
    'app-heat-counter-svg': HeatCounterSvg
  }
})
export default class CounterItem extends Vue {
  @Prop({ required: true }) private counter!: Counter;
  @Prop({ type: Boolean, default: true }) private outlined!: boolean;
  @Prop({ type: Boolean, default: true }) private showDetailsButton!: boolean;
  @Prop({ type: Boolean, default: false }) private showEditButton!: boolean;

  private get CounterUnit(): string {
    return lastDigits(this.counter.getValue());
  }

  private translateCounterResource(counter: Counter): string {
    const counterResource = counter.getResource().getResource();
    const resourceTranslationKey: string = counterResource === 'cold.water' || counterResource === 'hot.water'
      ? counterResource.split('.')[0]
      : counterResource;
    return this.$i18n.t(`screens.account.counters.resource_types.${resourceTranslationKey}`) as string;
  }
}
